<lib-header
  [showNav]="showNav"
  [client]="clientApp"
  (showFeedback)="showFeedbackModal()"
>
  <div class="d-flex flex-grow-1">
    <ul class="navbar-nav py-4">
      @if (showIgniteNav || showMortgageClubNavigation) {
        <!-- Mortgage Club Section -->
        @if (showMortgageClubNavigation) {
          <!-- Full Section - Show when not on Ignite routes -->
          @if (!isOnIgniteSection) {
            <li class="nav-item">
              <a
                class="nav-link fw-bold"
                routerLink="/"
                routerLinkActive="tab-active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                Mortgage Club
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="https://www.legalandgeneral.com/adviser/mortgage-club/referralpro/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Referral pro
              </a>
            </li>
            @if (hasRole(roles.procFeeHistory) || hasRole(roles.claims)) {
              <li class="nav-item">
                <a
                  class="nav-link"
                  routerLink="/procfee"
                  routerLinkActive="tab-active"
                >
                  Proc fee
                </a>
              </li>
            }
            <li class="nav-item">
              <a
                class="nav-link"
                href="https://www.legalandgeneral.com/adviser/mortgage-club/events/?cid=PartnerSite18342"
                target="_blank"
                rel="noopener noreferrer"
              >
                Events
              </a>
            </li>
            @if (hasAccessToMi) {
              <li class="nav-item">
                <a
                  class="nav-link"
                  routerLinkActive="tab-active"
                  [routerLink]="firstMiLink"
                >
                  MI & insights
                </a>
              </li>
            }
          }
          <!-- Collapsed Section - Show when on Ignite routes -->
          @if (isOnIgniteSection) {
            <li class="nav-item">
              <a
                class="nav-link fw-bold nav-section-collapsed"
                routerLink="/"
              >
                Mortgage Club
                <lib-svg-icon
                  icon="chevron-right"
                  class="text-colour-grayscale-900 svg-16-no-pad icon-inline-block-center"
                  [fill]="true"
                  [stroke]="true"
                />
              </a>
            </li>
          }
        }
      }
    </ul>

    <ul
      class="navbar-nav py-4"
      [class.nav-section-divider]="showIgniteNav && showMortgageClubNavigation"
    >
      @if (showIgniteNav || showMortgageClubNavigation) {
        <!-- Ignite Section -->
        @if (showIgniteNav) {
          <!-- Full Section - Show when not on Mortgage Club routes -->
          @if (!isOnMortgageClubSection) {
            <li
              class="nav-item"
              [class.ms-4]="showIgniteNav && showMortgageClubNavigation"
            >
              <a
                class="nav-link fw-bold"
                routerLinkActive="tab-active"
                [routerLink]="hasActiveSubscription ? hasSubscriptionBroker ? '/ignite' : '/ignite/non-broker-home' : '/ignite/subscribe'"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="ignite()"
              >
                Ignite
              </a>
            </li>
            @if (hasSubscriptionBroker) {
              <li class="nav-item">
                <a
                  class="nav-link"
                  routerLink="/ignite/outcome-history"
                  routerLinkActive="tab-active"
                >
                  Outcome history
                </a>
              </li>
            }
            @if (hasSubscriptionBroker && hasRole(roles.viewConsumerDuty)) {
              <li class="nav-item">
                <a
                  class="nav-link"
                  routerLink="/ignite/consumer-duty"
                  routerLinkActive="tab-active"
                >
                  Fair value
                </a>
              </li>
            }
            @if (hasSubscriptionBroker && hasRole(roles.savedSearches)) {
              <li class="nav-item">
                <a
                  class="nav-link"
                  routerLink="/ignite/saved-searches"
                  routerLinkActive="tab-active"
                >
                  Saved searches
                </a>
              </li>
            }
            @if (hasSubscriptionAdmin) {
              <li class="nav-item">
                <a
                  class="nav-link"
                  routerLink="/ignite/admin"
                  routerLinkActive="tab-active"
                >
                  Admin
                </a>
              </li>
            }
          }
          <!-- Collapsed Section - Show when on Mortgage Club routes -->
          @if (isOnMortgageClubSection) {
            <li
              class="nav-item fw-bold"
              [class.ms-4]="showIgniteNav && showMortgageClubNavigation"
            >
              <a
                class="nav-link nav-section-collapsed"
                [routerLink]="hasActiveSubscription ? '/ignite' : '/ignite/subscribe'"
              >
                Ignite
                <lib-svg-icon
                  icon="chevron-right"
                  class="text-colour-grayscale-900 svg-16-no-pad icon-inline-block-center"
                  [fill]="true"
                  [stroke]="true"
                />
              </a>
            </li>
          }
        }
      }
    </ul>
    <ul class="navbar-nav py-4 align-items-end ms-auto me-4">
      @if (showResourceCentreLink) {
        <li class="nav-item">
          <a
            href="https://www.legalandgeneral.com/adviser/mortgage-services/mortgage-technology/ignite/support/"
            class="nav-link"
            target="_blank"
          >
            Resource centre
          </a>
        </li>
      }
      <li class="nav-item">
        <a
          routerLink="/contact"
          class="nav-link"
          routerLinkActive="tab-active"
        >
          Contact
        </a>
      </li>
    </ul>
  </div>
</lib-header>

@if (showTrialWarningBanner) {
  <div class="alert alert-banner-warning alert-banner-warning-icon m-0 py-2">
    Your trial will end in {{trialEndDuration}}. To continue accessing Ignite, please update your bank details in
    <strong>Admin → Payment methods</strong>.
  </div>
}

<ng-template #userFeedbackTemplate>
  <lib-app-user-feedback />
</ng-template>
